import { useMemo } from "react";

import { isInMccmApp } from "../utils/user-agent/isInMccmApp";

export const useIsInMccmApp = () => useMemo(() => isInMccmApp(), []);
